import style from "./VideoCard.module.css";

import { Link } from "react-router-dom";
import Icon from "@/ui/icon/Icon";
import { secondsToMinutesSeconds } from "@/utils/helpers";

import { padZero } from "@/utils/helpers";

function VideoCard({ unit }) {
	const { bunny_duration } = unit.video_info;
	return (
		<div className={style.card}>
			<Link
				to={`/courses/${unit?.module?.course?.slug}/${unit?.module.slug}/${unit?.slug}`}
				className={style.thumbnail}
				style={{
					"--background": `url(${unit.thumbnail})`,
				}}
			>
				<div className={style.tag}>
					<Icon icon="fa-desktop" />
					<span>tehnologija</span>
				</div>
				<div className={style.likeCount}>
					<Icon icon="fa-heart" />
					<span>{padZero(unit?.like_count)}</span>
				</div>
			</Link>
			<div className={style.videoInfo}>
				<div className={style.title}>{unit?.name}</div>
				<div className={style.otherInfo}>
					<div className={style.item}>
						<Icon icon="fa-eye" />
						<span>{padZero(unit?.view_count)}</span>
					</div>
					<span className={style.sep}></span>
					<div className={style.item}>
						<Icon icon="fa-clock" />
						<span>{secondsToMinutesSeconds(bunny_duration)}</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default VideoCard;
